import { gql } from "@apollo/client";

export const INITIATE_PASSWORD_RESET = gql`
    mutation InitiatePasswordReset($email: String!) {
        initiatePasswordReset(email: $email) {
            success
            error
        }
    }
`;

export const VERIFY_PASSWORD_RESET_TOKEN = gql`
    query VerifyPasswordResetToken($resetToken: String!) {
        verifyPasswordResetToken(resetToken: $resetToken) {
            success
            error
        }
    }
`;


export const COMPLETE_PASSWORD_RESET = gql`
    mutation CompletePasswordReset($email: String!, $password: String!, $confirmPassword: String!, $resetToken: String!) {
        completePasswordReset(email: $email, password: $password, confirmPassword: $confirmPassword, resetToken: $resetToken) {
            success
            error
        }
    }
`;
